import axios from 'axios';

import AuthService from '../../state/auth.service';
import endpoints from '../endpoints';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    postPurchaseNewConsultant(email) {
        return axios
            .post(
                endpoints.GROUP_BASE + '/purchase',
                {
                    email: email,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Error purchasing new consultant ...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    getConsultancyTeamMembers() {
        return axios
            .get(endpoints.GROUP_BASE + '/consultants', {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    getEvents() {
        return axios
            .get(endpoints.GROUP_BASE + '/events', {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    getOrganizations() {
        return axios
            .get(endpoints.GROUP_BASE + '/organizations', {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    listOrganizationMetrics() {
        return axios
            .get(endpoints.GROUP_BASE + '/orgmetrics', {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    getGroupDetails() {
        return axios
            .get(endpoints.GROUP_BASE, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },
};
